import { useEffect, useRef } from 'react';
import { isNilOrEmpty } from '@pcty/utils';
export var usePerformanceTimeout = function (performance, performanceTimeout) {
    var defaultTimeout = 300;
    var _performanceTimeout = useRef(performanceTimeout !== null && performanceTimeout !== void 0 ? performanceTimeout : defaultTimeout);
    useEffect(function () {
        switch (performance) {
            case 'debounce':
            default:
                if (isNilOrEmpty(performanceTimeout)) {
                    _performanceTimeout.current = 300;
                }
                break;
            case 'throttle':
                if (isNilOrEmpty(performanceTimeout)) {
                    _performanceTimeout.current = 750;
                }
                break;
            case 'off':
                _performanceTimeout.current = 0;
                break;
        }
    }, [performance, performanceTimeout]);
    return _performanceTimeout.current;
};
